<template>
  <div class="copy-to-clipboard-wrapper" @click="copyContent">
    <i class="far fa-clone"></i>
    <span class="tooltip-text" v-if="showTooltip" :class="{ 'tooltip-success': isSuccess, 'tooltip-error': !isSuccess }">
      {{ tooltipMessage }}
    </span>
  </div>
</template>

<script>
export default {
  name: "CopyToClipboard",
  props: ["text"],
  data() {
    return {
      showTooltip: false,
      isSuccess: true,
      tooltipMessage: "บันทึกใส่คลิปบอร์ดสำเร็จ"
    };
  },
  methods: {
    async copyContent() {
      try {
        await navigator.clipboard.writeText(this.text);
        this.isSuccess = true;
        this.tooltipMessage = "บันทึกใส่คลิปบอร์ดสำเร็จ";
        this.showTooltipMessage();
      } catch (err) {
        console.error("Failed to copy: ", err);
        this.isSuccess = false;
        // this.tooltipMessage = "บันทึกใส่คลิปบอร์ดไม่สำเร็จ";
        // this.showTooltipMessage();
      }
    },
    showTooltipMessage() {
      this.showTooltip = true;
      // Hide tooltip after 2 seconds
      setTimeout(() => {
        this.showTooltip = false;
      }, 2000);
    }
  },
};
</script>

<style scoped>
.copy-to-clipboard-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.copy-to-clipboard-wrapper:hover {
  background-color: rgba(0, 0, 0, 0.05);
  transform: scale(1.1);
}

.copy-to-clipboard-wrapper:active {
  transform: scale(0.95);
}

.far.fa-clone {
  font-size: 16px;
  color: #6c757d;
  transition: color 0.3s ease;
  pointer-events: none;
}

.copy-to-clipboard-wrapper:hover .far.fa-clone {
  color: #495057;
}

.tooltip-text {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  opacity: 0;
  animation: fadeInOut 2s ease;
}

.tooltip-success {
  background-color: #28a745;
}

.tooltip-error {
  background-color: #dc3545;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

.tooltip-success::after {
  border-color: #28a745 transparent transparent transparent;
}

.tooltip-error::after {
  border-color: #dc3545 transparent transparent transparent;
}

@keyframes fadeInOut {
  0% { opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { opacity: 0; }
}
</style>